
window.waves = window.waves || {};

const generateUUID = () : string => {

    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Fallback implementation for browsers that don't support crypto.randomUUID -----------
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * <button type="button" data-app-login=”VRG” class="w-btn w-fit mr-12">Go to Dashboard</button>
 */
const initButtons = () => {
    const $buttons = document.querySelectorAll('[data-app-login]');
    for(const $button of $buttons) {

        // @ts-ignore
        $button.addEventListener('click', (evt: MouseEvent) => {
            const $btn = evt.currentTarget as HTMLButtonElement;
            if(!$btn) return;

            const appCode = $btn.getAttribute('data-app-login');
            if(!appCode) return;

            const redirect = $btn.getAttribute('data-app-rdr') ?? '';

            window.waves.wavesAppLogin(appCode, redirect);
        });
    }
};

const init = () => {

    window.waves.wavesAppLogin = (appCode: string, redirect: string) => {

        const storageKey = `app-login-${ appCode.toLowerCase() }`;

        if(window.localStorage.getItem(storageKey) === null) {
            const data = `${generateUUID()},${generateUUID()},${Math.round(
                Date.now() / 1000
            ).toString()},${appCode},14.0.0`;

            const token = window.btoa(data);

            window.location.href = `/login?loginToken=${ token }`;
        }
        else{
            window.location.href = redirect;
        }
    };

    initButtons();
};

init();

export {  };